import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Spin, Skeleton, Collapse, Table, Tabs, Empty, message, Tooltip } from 'components/shared/AntComponent';
import { Button, Form, Select, Input, InputNumber, TimePicker, DatePicker, TextArea, Radio } from 'components/shared/FormComponent';
import { AssoCandidateList, getExamDetail, saveAssCandidList,sendMailToCandidate } from 'services/store/actions/examAction';
import dayjs from 'dayjs';
import { getCourse, getPublicCourse, getSpecialisation } from 'services/store/actions/masterDataAction';
import { EditIcon, SendMailIcon, DisableSendMailIcon } from 'assets/icons/CustomIcons';
import { Modal } from 'antd';

interface ChildProps {
    slots: any;
    // applicantOptions: any;
    // department: any;
    callbackFunc1: () => void;
    duration: any;
    rowData: any;
    examUniqueId:any;
    // isPastDate: boolean;
    // tempOptions: any;
    // college: any;
    // examName: string;
    // totalMark: any;
}
const AssociateApplicant: React.FC<ChildProps> = ({ slots, duration, rowData,examUniqueId, callbackFunc1 }) => {
    const dispatch = useDispatch();
    const { examDetailInfo, loading4 } = useSelector((state: any) => state.exam);
    const examInfo = examDetailInfo?.data?.[0] || null;
    const [candList, setCandList]: any = useState([]);
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchVal, setSearchVal] = useState('');
    const { loading20, success20, error20, sendMailToCandidateLoading, sendMailToCandidateSuccess, sendMailToCandidateError,sendMailToCandidateInfo } = useSelector((state: any) => state.exam);
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const { loading30, pubCourseInfo, loading12: specLoading, specialisationInfo } = useSelector((state: any) => state.master);
    const { assoCandidList, loading18 } = useSelector((state: any) => state.exam);
    const [selectedRows, setSelectedRows] = useState<any[]>([]);
    const [showSuccessmsg, setShowSuccessmsg] = useState(false);
    const successmsg = showSuccessmsg ? success20 : false;
    const totalRecords = !loading18 ? assoCandidList?.data?.totalRecords : 0;
    const [showErrormsg, setShowErrormsg] = useState(false);
    const errormsg = showErrormsg ? error20 : false;
    const data = !loading18 ? assoCandidList?.data?.data : [];
const [isAllSelected, setIsAllSelected] = useState(false);
    const customLocale = {
        emptyText: <Empty className="p-2" description="No Applicant Available" />,
    };

    const courseOptions = useMemo(() =>
        !loading30 && pubCourseInfo?.data?.map((item: any) => ({
            label: item?.courseName,
            value: item?.masCourseID,
            actualID: 0,
        })) || [],
        [loading30, pubCourseInfo]
    );

    const specOptions = useMemo(() =>
        !specLoading && specialisationInfo?.data?.map((item: any) => ({
            value: item?.specializationId,
            label: item?.specializationName,
            id: item?.specializationId,
            description: item.description,
            actualID: 0
        })) || [],
        [specLoading, specialisationInfo]
    );

    const genderOptions: any = useMemo(() => [
        { value: "male", label: "Male" },
        { value: "female", label: "Female" },
        { value: "other", label: "Other" }
    ], []);

    function getCourseList() {
        const id = Number(localStorage.getItem('tenantID')) + "/" + 0;
        dispatch(getPublicCourse(id) as any);
    }

    function getSpecialisationDetails() {
        const id = Number(localStorage.getItem('tenantID')) + "/" + 0;
        dispatch(getSpecialisation(id) as any);
    }

    useEffect(() => {
        getCourseList();
        getSpecialisationDetails();
    }, []);

    const handleSubmit = () => {
        const candidates = selectedRows?.map((item: any) => ({
            "CandExamID": examDetailInfo?.data?.[0]?.examID,
            "candidateId": item.candidateId,
            "regno": item.regno || "",
            "firstName": item?.firstName || "",
            "middleName": item?.middleName || null,
            "lastName": item?.lastName || "",
            "email": item?.email || "",
            "qualifiedCourseID": item?.qualifiedCourseID || null,
            "qualifiedCourse": item?.qualifiedCourse || "",
            "specializationID": item?.specializationID || null,
            "specializationName": item?.specializationName || "",
            "createdOn": item?.createdOn || "",
            "status": item?.status || "Active",
            "accountId": item?.accountId || null,
            "accountName": item?.accountName || "",
            "tenantId": item?.tenantId || null,
            "preferredField": item?.preferredField || ""
        }))
        const inputJson = {
            "ExamID": rowData?.ExamID || "",
            "ExamSlotId": rowData?.ExamSlotId,
            "ExamName": examDetailInfo?.data?.[0]?.examName,
            "ExamDate": examDetailInfo?.data?.[0]?.examDate ? dayjs(examDetailInfo?.data?.[0]?.examDate).format('YYYY-MM-DD') : null,
            "DefaultMarks": "1",
            "CandExamStatus": "Active",
            "candidates": candidates || null
        }

        dispatch(saveAssCandidList(inputJson) as any);
        setShowErrormsg(true);
        setShowSuccessmsg(true);
    };
  useEffect(() => {
    if (data?.length > 0) {
        const associatedRows = data.filter((item: any) => item.isAssociated === true);

        const defaultKeys = associatedRows.map((item: any) => item.candidateId);

        setSelectedRowKeys(defaultKeys);   // ✅ keys
        setSelectedRows(associatedRows);   // 🔥 MUST ADD THIS
    }
}, [data]);

    useEffect(() => {
        if (successmsg) {
            message.success('Candidates associated to this exam successfully');
            setShowSuccessmsg(false);
            callbackFunc1();
        }
        if (errormsg) {
            if (error20?.message) {
                message.error(error20?.message);
            } else {
                message.error("Candidates couldn't associate with this exam");
            }
            setShowErrormsg(false);
        }
    }, [successmsg, errormsg]);

    const getMatchedLabels = (conditionIDs: any, conditionName: string, assoCondition: string) => {
        if (!conditionIDs) return "";

        const conditionValues = conditionIDs?.split(',')?.map(Number);

        let options = [];
        if (assoCondition === "dept") {
            options = specOptions;
        } else if (assoCondition === "course") {
            options = courseOptions;
        } else if (assoCondition === "gender") {
            return conditionName.toLowerCase(); // Return as-is in lowercase for gender
        }

        const matchedLabels = options
            .filter((option: any) => conditionValues.includes(option.value))
            .map((option: any) => option.label?.toLowerCase() || '');

        return matchedLabels.length > 0 ? matchedLabels : conditionName.toLowerCase();
    };
    console.log("rowData",rowData);

    const getAssociateCandid = (page: number, size: number, search: string) => {
        if (!rowData || !examDetailInfo) return;

        // const matchedLabels = getMatchedLabels(rowData?.ConditionIDs,rowData.ConditionName, rowData.IsAssoCondition);

        const inputJson = {
            "InputData": {
                "Status": "Active",
                "AccountId": rowData.AccountId,
                "TenantId": Number(localStorage.getItem('tenantID')),
                "AssoCondition": rowData.IsAssoCondition || "",
                "ConditionID": Array.isArray(rowData.ConditionIDs) ? rowData.ConditionIDs?.join(','): rowData.ConditionIDs,
                "ExamId": rowData?.ExamID
            },
            "DataFinder": {
                "PageSize": size,
                "CurrentPage": page,
                "SortByColumn": "",
                "SortBy": "asc",
                "SearchData": search || ""
            }
        };
        dispatch(AssoCandidateList(inputJson) as any);
    };

    useEffect(() => {
     const hasRequiredData =
    examDetailInfo?.data?.length > 0 &&
    rowData?.ExamSlotId &&
    courseOptions.length > 0 &&
    specOptions.length > 0;

        if (hasRequiredData) {
            getAssociateCandid(pageIndex, pageSize, searchVal);
        }
    }, [
    examDetailInfo?.accountId,
    rowData?.ExamSlotId,
    rowData?.ConditionName,
    rowData?.IsAssoCondition,
    courseOptions.length,
    specOptions.length,
    pageIndex,
    pageSize,
    searchVal
]);

    const columns: any = [
        {
            title: 'Reg No',
            dataIndex: 'regno',
            key: 'regno',
        },
        {
            title: 'First Name',
            dataIndex: 'firstName',
            key: 'firstName',
        },
        {
            title: 'Last Name',
            dataIndex: 'lastName',
            key: 'lastName',
            render: (_: any, record: any) => {
                return (
                    <div>{record?.lastName || "--"}</div>
                )
            }
        },
        {
            title: 'Gender',
            dataIndex: 'gender',
            key: 'gender',
            align: 'center',
        },
        {
            title: 'Mobile No',
            dataIndex: 'mobileNumber',
            key: 'mobileNumber',
            align: 'center',
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Course',
            dataIndex: 'qualifiedCourse',
            key: 'qualifiedCourse',
            render: (accountname: any) => {
                return <div>{accountname || '--'}</div>
            }
        },
       {
    title: 'Action',
    key: 'action',
    align: 'center',
    render: (_: any, record: any) => {
        return (
            <Tooltip title="Send mail to this candidate">
                <span
                    className="pointer text-success"
                    onClick={() => handleSendSingle(record)}
                >
                    <SendMailIcon size={18} />
                </span>
            </Tooltip>
        );
    }
}
    ];

    const paginationConfig: any = {
        position: ['bottomRight'],
        current: pageIndex,
        pageSize: pageSize,
        total: totalRecords,
        onChange: (page: number, pageSize: number) => {
            if (loading18) return;
                   setPageIndex(page);
                   setPageSize(pageSize);
                //    getAssociateCandid( page, pageSize,searchVal);
               },
               itemRender: (current: any, type: string, originalElement: any) => {
                   if (type === 'prev') {
                       return <Button className="prev-btn">Previous</Button>;
                   }
                   if (type === 'next') {
                       return <Button className="next-btn">Next</Button>;
                   }
                   return originalElement;
               },
    };

const handleSendSingle = (record: any) => {
    Modal.confirm({
        title: "Send Mail",
        content: `Send mail to ${record.firstName}?`,
        onOk: () => sendSingle(record)
    });
};



const sendSingle = (record: any) => {
    const url = window.origin;

    const payload = {
        ExamUniqueId: examUniqueId,
        TenantId: Number(localStorage.getItem('tenantID')),
        ExamUrl: `${url}/guest-login/${examUniqueId}`,
        CandidateID: record.candidateId,
        IsSendOverride: false
    };

    dispatch(sendMailToCandidate(payload) as any);
};

const handleSendSelected = () => {
    if (selectedRows.length === 0) {
        message.warning("Please select at least one candidate");
        return;
    }

    Modal.confirm({
        title: "Send Mail",
        content: `Send mail to ${selectedRows.length} candidate(s)?`,
        onOk: () => sendBulk()
    });
};

const sendBulk = async () => {
    const url = window.origin;

    for (const candidate of selectedRows) {
        const payload = {
            ExamUniqueId: examUniqueId,
            TenantId: Number(localStorage.getItem('tenantID')),
            ExamUrl: `${url}/guest-login/${examUniqueId}`,
            CandidateID: candidate.candidateId,
            IsSendOverride: false
        };

        await dispatch(sendMailToCandidate(payload) as any);
    }

    message.success("Mail sent to selected candidates");
};

const rowSelection: any = {
    selectedRowKeys,

    onChange: (newSelectedRowKeys: React.Key[], newSelectedRows: any[]) => {
        const currentPageKeys = data.map((item: any) => item.candidateId);

        let updatedKeys = [...selectedRowKeys];

        // Add newly selected
        newSelectedRowKeys.forEach((key) => {
            if (!updatedKeys.includes(key)) {
                updatedKeys.push(key);
            }
        });

        // Remove unchecked from current page
        currentPageKeys.forEach((key: React.Key) => {
            if (!newSelectedRowKeys.includes(key)) {
            updatedKeys = updatedKeys.filter((k: React.Key) => k !== key);
            }
        });

        // Update rows
const updatedRowsMap = new Map();

        selectedRows.forEach((row: any) => {
            updatedRowsMap.set(row.candidateId, row);
        });

        newSelectedRows.forEach((row: any) => {
            updatedRowsMap.set(row.candidateId, row);
        });

        currentPageKeys.forEach((key: React.Key) => {
            if (!newSelectedRowKeys.includes(key)) {
            updatedRowsMap.delete(key);
            }
        });

        setSelectedRowKeys(updatedKeys);
        setSelectedRows(Array.from(updatedRowsMap.values()));

        // if manual change → disable "select all"
        setIsAllSelected(false);
    },

    onSelectAll: async (selected: boolean) => {
        if (selected) {
            setIsAllSelected(true);

            // 🔥 Call API to get ALL data (important)
            const inputJson = {
                InputData: {
                    Status: "Active",
                    AccountId: rowData.AccountId,
                    TenantId: Number(localStorage.getItem('tenantID')),
                    AssoCondition: rowData.IsAssoCondition || "",
                    ConditionID: Array.isArray(rowData.ConditionIDs)
                        ? rowData.ConditionIDs.join(',')
                        : rowData.ConditionIDs,
                    ExamId: rowData?.ExamID
                },
                DataFinder: {
PageSize: Math.min(totalRecords, 500),
                    CurrentPage: 1,
                    SortByColumn: "",
                    SortBy: "asc",
                    SearchData: searchVal || ""
                }
            };

            const res: any = await dispatch(AssoCandidateList(inputJson) as any);

            const allData = res?.payload?.data?.data || [];

            const allKeys = allData.map((item: any) => item.candidateId);

            setSelectedRowKeys(allKeys);
            setSelectedRows(allData);
        } else {
            // Unselect all
            setIsAllSelected(false);
            setSelectedRowKeys([]);
            setSelectedRows([]);
        }
    }
};

    const goToPreviousScreen = () => {
        // navigate('/exam');
    }

    return (
        <div className="border-top pt-3">
            <div>
                <div className='bg-light p-3 rounded d-flex mx-2'>
                    <div className='col-md-2'>
                        <h6 className="text-primary fw-bold">Slot Name</h6>
                        <p className="mb-0">{rowData?.ExamSlotName || "--"}</p>
                    </div>
                    <div className='col-md-2'>
                        <h6 className="text-primary fw-bold">Start Time</h6>
                        <p className="mb-0">{rowData?.ExamStartTime || "--"}</p>
                    </div>
                    <div className='col-md-2'>
                        <h6 className="text-primary fw-bold">End Time</h6>
                        <p className="mb-0">{rowData?.ExamEndTime || "--"}</p>
                    </div>
                    <div className='col-md-2'>
                        <h6 className="text-primary fw-bold">Capacity</h6>
                        <p className="mb-0">{rowData?.TotalCapacity || "--"}</p>
                    </div>
                    <div className='col-md-2'>
                        <h6 className="text-primary fw-bold">Associate Condition</h6>
                        <p className="mb-0">{rowData?.IsAssoCondition?.toLowerCase() === "dept" ? "Department" :
                            rowData?.IsAssoCondition?.toLowerCase() === 'course' ? "Course" : rowData?.IsAssoCondition?.toLowerCase() === "gender" ? "Gender" : "--"}</p>
                    </div>
                    <div className='col-md-2'>
                        <h6 className="text-primary fw-bold">Department/Course/Gender</h6>
                        <p className="mb-0">{Array.isArray(rowData.ConditionName) ? rowData?.ConditionName?.join(', ') : rowData?.ConditionName?.toString() || "--"}</p>
                    </div>
                </div>
                <div className="custom-table m-2">
                    {/* {hasSelected ? `Selected ${selectedRowKeys.length} items` : null} */}
                    <Spin spinning={loading18}>
                        <div className='d-flex justify-content-between' style={{ marginBottom: '10px', fontWeight: 500 }}>
    Selected: {selectedRowKeys.length} / {totalRecords}  <Button
    type="primary"
    className="mb-2"
    disabled={selectedRows.length === 0}
    onClick={handleSendSelected}
>
    Send Mail to Selected ({selectedRows.length})
</Button></div>
   
                        <Table
                            rowSelection={rowSelection}
                            columns={columns}
                            className="border"
                            scroll={{ x: 'calc(230px + 50%)' }}
                            dataSource={data}
                            rowKey="candidateId"
                            loading={loading18 || loading4}
                            pagination={paginationConfig}
                            locale={customLocale}
                        />
                    </Spin>
                </div>
                <div className="text-end">
                    <Button type="primary" onClick={handleSubmit} loading={loading20}>Associate</Button>
                </div>
            </div>
        </div>
    )
}

export default AssociateApplicant;